import { injectIntl } from "react-intl";
import React, { useEffect, useState } from "react";
import { LineChart, Line, CartesianGrid, ResponsiveContainer } from "recharts";
import { SparkLineChart } from "@mui/x-charts";

const RevenueCard = (props) => {

    const [list, setList] = useState([])

    useEffect(() => {
        let data
        if (props.item?.revenueArray) {
            data = Array.from(props.item?.revenueArray, (item, index) => ({
                x: index,
                y1: item.smsRevenue,
                y2: item.emailRevenue
            }));
        }
        setList(data)
    }, [props])

    return (
        <div className={ "DashboardCardContainer" }>
            <div className={ "DashboardTablesTitle" }>{ props.title }</div>
            <div className={ "HorizontalDivider" }></div>
            <div className={ "flex justify-between w-full" }>
                <div className={ "flex flex-col gap-5" }>
                    <div>
                        <div className={ "DashboardListName" }>Total</div>
                        <div className={ "DashboardListNameTitle" }>{ props.item?.dateString }</div>
                    </div>
                    <div
                        className={ "DashboardCardPrice" }>{ props.type === "SMS" ? (props?.item?.smsRevenue === 0 ? "-" : "$" + props.item?.smsRevenue?.toFixed(2)) : props.type === "Email" ? (props?.item?.emailRevenue === 0 ? "-" : "$" +props.item?.emailRevenue?.toFixed(2)) : props?.item?.totalRevenue?.toFixed(2) }</div>
                </div>
                { props.type && props.item?.revenueArray?.length > 0 &&
                    <div>
                        <SparkLineChart
                            data={ props.type === "SMS" ? props.item?.smsArray?.map((revenue) => revenue.smsRevenue) : props.item?.emailArray?.map((revenue) => revenue.emailRevenue) }
                            height={ 100 }
                            width={ 200 }
                            curve="natural"
                            colors={ ["#7E50EA"] }
                            showHighlight={true}
                            showTooltip={true}
                            highlightScope={{ highlighted: 'item', faded: 'global' }}
                        />
                    </div>
                }
                { props.type === null &&
                    <div>
                        <ResponsiveContainer height={ 100 } width={ 200 }>
                            <LineChart data={ list }>
                                <Line
                                    type="monotone"
                                    dataKey="y1"
                                    stroke="#7E50EA"
                                    strokeWidth={ 3 }
                                    dot={ false }
                                />
                                <Line
                                    type="monotone"
                                    dataKey="y2"
                                    stroke="#D3D3D3"
                                    strokeWidth={ 3 }
                                    dot={ false }
                                />
                                <CartesianGrid stroke="#f5f5f5" vertical={ false } horizontal={ false }/>
                            </LineChart>
                        </ResponsiveContainer>
                    </div>
                }
            </div>
            <div className={ "flex w-full" }>
                { (props.type === "SMS" || !props.type) &&
                    <div className={ "flex gap-[6px] w-[46%]" }>
                        <div className={ "DashboardCardSMSIconBackground" }>
                            <img alt={ "Logo" } src={ "/media/icons/chat.svg" } className={ "w-4 h-4" }/>
                        </div>
                        <div>
                            <div>SMS Revenue</div>
                            <div>{ props?.item?.smsRevenue === 0 ? "-" : "$" + (props?.item?.smsRevenue)?.toFixed(2) }</div>
                        </div>
                    </div>
                }
                { !props.type &&
                    <div className={ "w-[8%]" }>
                        <img alt={ "Logo" } src={ "/media/icons/cardDivider.png" } className={ "h-10 w-[1px]" }/>
                    </div>
                }
                { (props.type === "Email" || !props.type) &&
                    <div className={ "flex gap-[6px] w-[46%]" }>
                        <div className={ "DashboardCardEmailIconBackground" }>
                            <img alt={ "Logo" } src={ "/media/icons/mailPurple.svg" } className={ "w-4 h-4" }/>
                        </div>
                        <div>
                            <div>Email Revenue</div>
                            <div>{ props?.item?.emailRevenue === 0 ? "-" : "$" + (props?.item?.emailRevenue)?.toFixed(2) }</div>
                        </div>
                    </div>
                }
            </div>
        </div>
    );
}

export default injectIntl(RevenueCard);
